import { render } from "./SingleUserDisplay.vue?vue&type=template&id=d6d3b346&scoped=true"
import script from "./SingleUserDisplay.vue?vue&type=script&lang=js"
export * from "./SingleUserDisplay.vue?vue&type=script&lang=js"

import "./SingleUserDisplay.vue?vue&type=style&index=0&id=d6d3b346&scoped=true&lang=css"

import exportComponent from "/app/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d6d3b346"]])

export default __exports__